import styled from "styled-components";
import { Radio as ANTRadio } from "antd";
import { themeProp } from "../theme";

const Radio = styled(ANTRadio)`
  & .ant-radio-checked::after {
    border: 1px solid ${themeProp("palette.secondary")};
  }

  & .ant-radio-checked .ant-radio-inner {
    border-color: ${themeProp("palette.secondary")};
  }

  & .ant-radio-inner::after {
    background-color: ${themeProp("palette.surface")};
  }

  & .ant-radio-checked .ant-radio-inner {
    background-color: ${themeProp("palette.secondary")};
  }

  & .ant-radio-inner {
    background-color: ${themeProp("palette.surface")};
  }

  & .ant-radio-checked.ant-radio-disabled .ant-radio-inner {
    background-color: ${themeProp("palette.secondary")};
  }

  & .ant-radio-checked.ant-radio-disabled .ant-radio-inner::after {
    background-color: ${themeProp("palette.surface")};
  }
`;

export default Radio;

export const RadioGroup = styled(ANTRadio.Group)`
  & .ant-radio-button-wrapper {
    padding: 12px 20px;
    height: 48px;
    color: ${themeProp("palette.body")} !important;
    border-color: ${themeProp("palette.gray2")} !important;
    font-size: ${themeProp(`typography.body.fontSize`)} !important;
    font-family: ${themeProp(`typography.body.fontFamily`)} !important;
    font-weight: 600 !important;
    line-height: ${themeProp(`typography.body.lineHeight`)} !important;
  }

  & .ant-radio-button-wrapper:hover:not(.ant-radio-button-wrapper-checked) {
    color: ${themeProp("components.button.primary.hover")} !important;
  }

  & .ant-radio-button-wrapper.ant-radio-button-wrapper-checked {
    color: white;
    background-color: ${themeProp("palette.gray4")};
    border-color: ${themeProp("palette.gray4")};
  }

  & .ant-radio-button-wrapper.ant-radio-button-wrapper-checked::before {
    background-color: ${themeProp("palette.gray4")};
  }
`;
export const RadioButton = styled(ANTRadio.Button)``;
